import { checkDefined } from './checkDefined';
export const getNodeKey = (node) => checkDefined(node.name.split('.', 1)[0]);
